module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/costume_type_kimono-fe91ec287e49fea6bf6d41a05e8e3f5f.webp";